module.exports = __webpack_public_path__ + "static/media/bg-auth.be0898e7.jpeg";